const organizationGetKey = (orgId)=>[
        'organization.get',
        orgId
    ];

export { organizationGetKey };
//# sourceMappingURL=organizationGetKey.mjs.map
